module.exports = __webpack_public_path__ + "img/marker-primary.306d033b.svg";